<template>
    <div class="xufei">
        <h3>自动续费协议</h3>
        <p class="top">欢迎您开通自动续费功能。</p>
        <p>自动续费功能是由小盒学习的所有者为小盒学习用户（以下更多的称之为「您」）提供的，按照您的设置自动从您的指定第三方支付账户中扣除费用的功能。</p>
        <p>请您务必审慎阅读、充分理解本协议各条款内容，特别是免除或限制责任的相应条款。<strong>小盒学习将以加粗或斜体加粗等形式提示您注意限制、免责条款。未成年人应在法定监护人的陪同下阅读本协议，并确认有权利绑定其他付费账户。</strong></p>
        <p>您确认开通自动续费功能，视为您已阅读并同意接受本协议的约束。如果您对本协议的任何条款表示异议，您可以选择不开通本功能。</p>
        <h3>服务内容</h3>
        <p>1. 为帮助您更便捷的购买（或订阅）小盒学习的付费产品，我们为您提供自动续费功能。当您明确同意开通自动续费功能，即授权小盒学习在符合约定的续费条件时，从您绑定的第三方支付账户中扣除再次购买该付费产品所需支付的费用。</p>
        <p>2. 此功能适用于小盒学习提供的「小盒学习月度会员」等需要定期续费的产品。</p>
        <h3>开通自动续费</h3>
        <p>1. 您开通自动续费功能后，您的小盒学习帐号将与您指定的第三方支付账户绑定。</p>
        <p><strong>2. 我们将在您购买的产品到期前的 24 小时内自动扣除下一期费用，并延续相应的服务内容、服务条件及服务期限。</strong></p>
        <p><strong>3. 如因非可归因于小盒学习的原因（如第三方系统故障、账户限额、账户余额不足等）造成续费失败，我们将按照「到期未续费」处理，停止向您提供相应服务。您应自行承担可能产生的不利后果。</strong></p>
        <p>4. 部分苹果用户不登录小盒学习帐号仍可购买付费产品。此类情况下，我们会按照用户购买产品时使用的设备（IMEI 码）记录购买情况，并将第三方支付账户与该设备绑定。 <strong>如果您在未登录小盒学习帐号的情况下购买了付费产品，但设备不再处于您控制之下，包括但不限于遗失或赠送他人，您可以关闭自动续费而避免持续付费。</strong></p>
        <h3>优惠活动及优惠价</h3>
        <p>1. 我们可能会根据业务需要或市场情况不时的调整产品价格，并在「会员开通页」向用户公示。除双方在相应产品开通自动续费功能时，已就各期价格进行了明确约定的情况外，如果自动续费时的价格高于您初次购买时的价格，我们会获取您的同意。如果自动续费时的价格低于您初次购买时的价格，我们将直接扣除相应款项。</p>
        <p>2. 假设您通过使用兑换码等非付费购买途径获得相应产品的延期，则Android系统自动续费的启动时间顺延至您获得延期的产品到期前一天。iOS系统自动续费的启动时间仍依照开通当前自动续费套餐时的时间顺延所选择自动续费套餐的时间到期前一天，免费时间将与付费的会员时间到期后开始消耗。</p>
        <h3>关闭自动续费</h3>
        <p>1. 您仅可以从第三方支付账户（或系统）中关闭自动续费功能。关闭路径如下：</p>
        <p><strong>·</strong> 苹果设备：在 iCloud 支付功能中关闭。路径为：设置 → iTunes Store 与 App Store → Apple ID → 查看 Apple ID → 账户设置 → 订阅。</p>
        <p><strong>·</strong> 安卓设备：在微信钱包的支付功能中关闭。路径为：我 → 钱包 → 支付管理 → 自动扣费。</p>
        <p>2. 因操作系统升级等原因导致路径调整的而您无法正确关闭自动续费的，您可以咨询设备厂家或系统服务商，也可以私信联系我们的客服人员，我们将尽力为您提供解决方案。</p>
        <p><strong>3. 关闭本功能视为您撤销给予小盒学习的从第三方支付账户扣除费用的授权。但此撤销不影响小盒学习在您撤销前已完成的扣款。</strong></p>
        <p><strong>4. 无论因何原因，您终止使用相应付费产品服务的，相应已开通的自动续费功能都需要您自行操作关闭。如您未关闭，小盒学习将正常进行自动扣款的操作，一旦扣款成功，小盒学习将为您正常延续相应服务。</strong></p>
        <h3>协议修改</h3>
        <p><strong>1. 根据互联网的发展和有关法律、法规及规范性文件的变化，或者因小盒学习业务发展需要，小盒学习有权对本协议的条款作出修改或变更，一旦本协议的内容发生变动，小盒学习将根据实际情况选择以包括但不限于系统提示、公告、站内信等方式提示您。</strong></p>
        <p><strong>2. 如果您不同意小盒学习对本协议相关条款所做的修改，您有权关闭自动续费。如果您继续使用，则视为您接受小盒学习对本协议相关条款所做的修改。</strong></p>
        <h3>适用法律及争议解决</h3>
        <p>1. 本协议的成立、生效、履行、解释及争议的解决均应适用中华人民共和国大陆地区法律。如本协议的任何约定因与中华人民共和国大陆地区的法律抵触而无效，则这些条款将按照尽可能接近本协议原条文的目的进行重新解释，本协议其它约定仍应具有完整的效力及效果。</p>
        <p><strong>2. 本协议的签署地点为中华人民共和国北京市朝阳区。若您与小盒学习发生争议的，双方应尽量友好协商解决。协商不成，双方均同意将争议提交至本协议签订地有管辖权的法院管辖。</strong></p>
    </div>
</template>

<script>
export default {
    methods: {
        
    }
}
</script>

<style lang="scss" scoped>
    .xufei {
        padding: .4rem .3rem .6rem;
        background-color: #fff;
        // .top {
        //     font-family: PingFangSC-Medium;
        // }
        h3 {
            font-family: PingFangSC-Medium;
            font-size: .36rem;
            color: #4a4b4c;
            font-weight: normal;
            margin: .2rem 0;
        }
        p {
            font-size: .28rem;
            font-family: PingFangSC-Regular;
            font-size: .28rem;
            line-height: .48rem;
            margin: .2rem 0;
        }
    }
</style>